import { styled } from '$utils/theme'
import Calendar from 'react-calendar'
import { rem } from 'polished'

export const StyledCalendar = styled(Calendar)`
  border: solid 1px ${p => p.theme.colors.grey} !important;
  font-size: 14px;
  width: 285px !important;

  .selected {
    abbr {
      padding: 7px;
      border-radius: 50%;
      background-color: ${p => p.theme.colors.darkGrey};
      color: ${p => p.theme.colors.white};
    }
  }
  .small-selected {
    abbr {
      padding: 7px 11px;
      border-radius: 50%;
      background-color: ${p => p.theme.colors.darkGrey};
      color: ${p => p.theme.colors.white};
    }
  }
  .eleven-selected {
    abbr {
      padding: 7px 8px;
      border-radius: 50%;
      background-color: ${p => p.theme.colors.darkGrey};
      color: ${p => p.theme.colors.white};
    }
  }
  .react-calendar__tile--active {
    background: ${p => p.theme.colors.white};
    color: ${p => p.theme.colors.menu} !important;
  }
  .react-calendar__tile--active:enabled:focus {
    background: ${p => p.theme.colors.white};
  }
  .react-calendar__tile:enabled:hover {
    background-color: ${p => p.theme.colors.white};
  }
  .react-calendar__navigation {
    margin-bottom: 0;
  }
  .react-calendar__tile {
    padding: ${p => rem(p.theme.sizes.base)} ${p => rem(p.theme.sizes.tiny)};
  }
`



// WEBPACK FOOTER //
// ./src/views/components/MultipleDatepicker/MultipleDatepicker.style.ts